<app-navigator [navigator]="navigator"></app-navigator>
<hr>
<ng-container *ngIf='me; else waiting'>
    
    <div class="actionBar">
            <h5  class="roboSubTitle col">{{me.username}}<br *ngIf="innerWidth! <= 767"></h5>
           
            <button  type="submit" class="btn btn-primary btnAr4m" style="margin-left: 10px;" (click)='save()'>{{ 'general.update' | translate }}</button>
        
    </div>
    <hr>
    <div class="row">
        <div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <!-- USERNAME  -->
            <label for="username" class="roboSubTitle">Username</label>
            <input class="form-control" type="text" id="username" [(ngModel)]="utente!.email" readonly>
        </div>
          
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"  [ngStyle]="{'padding-left': innerWidth! <= 767 ? 0 : 15 + 'px'}">
            <label class="roboSubTitle">{{(utente!.is_active == 't' ? 'users.editor.enabled'  : 'users.editor.noEnabled') | translate}}</label>
            <img [src]="'assets/icone_varie/' + (utente!.is_active == 't' ? 'cerchio_check.svg' : 'error.svg')" style="width:30px; height: auto; padding : 5px">
            
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}" >
            <div class="btnWithLabel"  [ngStyle]="{'padding-left': innerWidth! <= 767 ? 0 : 15 + 'px'}">
                <label for="btnPass" class="roboSubTitle">Password:</label>
                <button  class="btn btn-primary btnAr4m" (click)="changePassword()" style='margin-left: 20px;'>{{'profile.changePw' | translate}}</button>
                
            </div>
        </div>

        <div [ngClass]="{'col-1' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
            [ngStyle]="{'padding-left': innerWidth! <= 767 ? 0 : 15 + 'px'}">
            <label class="roboSubTitle">Logo</label>
            <div class="d-flex align-items-end">
                <button type="button" class="btn btn-primary btnAr4m" (click)="openLogoModal(logoModal)">Carica</button>
                <img [src]="'assets/icone_varie/' + ((utente.img_logo_path != '') ? 'cerchio_check.svg' : 'error.svg')"
                    style="width:30px; height: auto; padding : 5px" [ngbTooltip]="((utente.img_logo_path != '') ? 'Configurato' : 'Non configurato')">
            </div>
        </div>
    </div>
        
    <div class="row" style="margin-top:20px"> 
        
        <!-- NOTIFICHE FATT -->
        <div class="form-group form-check col-4" style="margin-bottom: 5px;">
            <!--<div class="userCheckBox" >
                <input type="checkbox" class="form-check-input"  [(ngModel)]="me.abilita_mail">
                <label class="form-check-label" for="securOrder">{{'users.editor.notifiche_fatt' | translate}}</label>
            </div>-->
            <label class="roboSubTitle">{{'users.editor.notifiche_fatt' | translate}}</label>
            <br/>
            <div class="btn-group px-2">
                <button type="button" [ngClass]="(notifiche.RC ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('RC');" [ngbTooltip]="'Ricevi notifiche di ricevuta di consegna'"
                    class="btn btn-success mx-1">RC</button>
                <button type="button" [ngClass]="(notifiche.MC ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('MC');" [ngbTooltip]="'Ricevi notifiche di mancata consegna'"
                    class="btn btn-success mx-1">MC</button>
                <button type="button" [ngClass]="(notifiche.NS ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('NS');" [ngbTooltip]="'Ricevi notifiche di scarto'"
                    class="btn btn-success mx-1">NS</button>
                <button type="button" [ngClass]="(notifiche.NE ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('NE');" [ngbTooltip]="'Ricevi notifiche di esito PA'"
                    class="btn btn-success mx-1">NE</button>
                <button type="button" [ngClass]="(notifiche.DT ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('DT');" [ngbTooltip]="'Ricevi notifiche di decorrenza termini'"
                    class="btn btn-success mx-1">DT</button>
            </div>
        </div>

        <div class="form-group form-check col-4">
            <label class="roboSubTitle">Email per ricezione notifiche</label>
            <div class="d-flex align-items-end">
                <input class="form-control" type="text" [(ngModel)]="notifiche.mailNotifiche">
                <button type="button" class="btn btn-success ms-2" (click)="setNotifica('');">Salva</button>
            </div>
            
        </div>

        <div class="form-group form-check col-4">
            <label class="roboSubTitle">Canali notifiche push</label>
            <div class="d-flex align-items-end">
                <button type="button" class="btn btn-primary btnAr4m" (click)="openNotificheModal(notificheModal)">Configura</button>
                <img [src]="'assets/icone_varie/' + ((notifiche.push != '' && notifiche.token != '') ? 'cerchio_check.svg' : 'error.svg')"
                    style="width:30px; height: auto; padding : 5px" [ngbTooltip]="((notifiche.push != '' && notifiche.token != '') ? 'Configurato' : 'Non configurato')">
            </div>
        </div>

        <!--<div class="form-group form-check col-4">
            <label class="roboSubTitle">Url per notifiche push</label>
            <div class="d-flex align-items-end">
                <input class="form-control" type="text" [(ngModel)]="notifiche.push">
                <button type="button" class="btn btn-success ms-2" (click)="setNotifica('');">Salva</button>
            </div>
            
        </div>-->

        <ng-template #notificheModal let-modal>
            <div class="modal-header">
                <h4 class="modal-title roboTitle">Configura notifiche push</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label class="roboSubTitle">Url per notifiche push</label>
                    <input class="form-control" type="text" [(ngModel)]="notificheDraft.push">
                </div>
                <div class="mb-3">
                    <label class="roboSubTitle">Token di autenticazione</label>
                    <input class="form-control" type="text" [(ngModel)]="notificheDraft.token">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Annulla</button>
                <button type="button" class="btn btn-success btnAr4m" (click)="saveNotificheModal(modal)">Salva</button>
            </div>
        </ng-template>

        <ng-template #logoModal let-modal>
            <div class="modal-header">
                <h4 class="modal-title roboTitle">Carica logo</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
            </div>
            <div class="modal-body">
                <div (click)="fileInput.click()" class="w-20 h-20 overflow-hidden border border-gray-200 rounded-full dark:border-gray-800">
                <img [src]="logoSafeUrl" alt="logo" />
                <input type="file" #fileInput style="display: none" accept="image/jpeg, image/png, image/webp" (change)="salvaLogoAzienda($event, modal)">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Annulla</button>
            </div>
        </ng-template>
        
    </div>
    <hr>
    <div class="actionBar">
        <h5  class="roboSubTitle col" style="margin-top: 20px; margin-bottom: 20px;">{{ 'profile.generalData' | translate }}<br *ngIf="innerWidth! <= 767"></h5>
    </div>
    <hr>
    <div class="row">
        <div class="col-6">
            <label  class="roboSubTitle">Denominazione</label>
            <input class="form-control" type="text"  [(ngModel)]="utente!.denominazione">
        </div>
        <!--<div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" *ngIf="(me!.role =='A' || me!.role=='S')">
             SELECT MODALITÀ RICEZIONE FATTURE PASSIVE 
            <label  class="roboSubTitle">{{ 'users.editor.receivingMode' | translate }}</label>
            <app-select class="selectDm7" 
                [options]="recWays" [key]="'key'" [value]="'value'"
                [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="me.mod_ric_fp"
                (change)="me.mod_ric_fp = $event.key"></app-select>
        </div>-->
        <!--<div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" *ngIf="(me!.role !='A' && me!.role!='S')">
             SELECT MODALITÀ RICEZIONE FATTURE PASSIVE 
            <label  class="roboSubTitle" [ngClass]="me.mod_ric_fp=='' ? 'colorRed': ''">{{ 'users.editor.receivingMode' | translate }}</label>
            <app-select class="selectDm7" 
                [options]="recWays" [key]="'key'" [value]="'value'"
                [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="me.mod_ric_fp"
                (change)="me.mod_ric_fp = $event.key" [valClass]="me.mod_ric_fp=='' ? 'borderRed': ''"></app-select>
        </div>-->
          <!--<div  [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             CODICE UNIVOCO 
            <label  class="roboSubTitle" [ngClass]="(me.mod_ric_fp=='C' && (me.codice_univoco== undefined || me.codice_univoco.length==0) && (me!.role !='A' && me!.role!='S')) ?'colorRed':''">{{ 'users.editor.uCode' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="me.codice_univoco" [ngClass]="(me.mod_ric_fp=='C' && (me.codice_univoco== undefined || me.codice_univoco.length==0) && (me!.role !='A' && me!.role!='S')) ?'borderRed':''">
          </div>-->

        <!-- <div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            EMAIL PEC 
            <label  class="roboSubTitle" [ngClass]="(me.mod_ric_fp=='P' && (me.email_pec== undefined || me.email_pec.length==0) && (me!.role !='A' && me!.role!='S')) ?'colorRed':''">Email PEC</label>
            <input class="form-control" type="text"  [(ngModel)]="me.email_pec" [ngClass]="(me.mod_ric_fp=='P' && (me.email_pec== undefined || me.email_pec.length==0) && (me!.role !='A' && me!.role!='S')) ?'borderRed':''">
          </div> -->
        <!-- <div  [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            PASSWORD PEC  
            <label  class="roboSubTitle" >Password PEC</label>
            <input class="form-control" [type]="pwFieldType" id='password-field'  [(ngModel)]="me.password_pec" >
            <span toggle="#password-field" class="bi field-icon toggle-password" (click)="changeVisibility()"
            [ngClass]="{'bi-eye-slash-fill' : hidePw, 'bi-eye-fill' : !hidePw}"></span>
         </div>-->
         
         
         
    </div>
    <div class="row" style="margin-top:20px">
        <div class="col-4">
            <!-- PARTITA IVA  -->
            <label  class="roboSubTitle">{{'configuration.rubrica.table.piva' | translate}}</label>
            <input class="form-control" type="text" maxlength="11" [(ngModel)]="utente!.partita_iva" oninput="javascript: this.value= this.value.toLocaleUpperCase(); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
        </div>
        <div class="col-4">
            <!-- CODICE FISCALE  -->
            <label  class="roboSubTitle">{{'configuration.rubrica.cf' | translate}}</label>
            <input class="form-control" type="text"  [(ngModel)]="utente!.codice_fiscale" [ngClass]="(utente!.codice_fiscale.length == 0)?'borderRed':''">
        </div>
        <div  [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <!-- REGIME FISCALE  -->
            <label  class="roboSubTitle">{{ 'users.personal.rf' | translate }}</label>
            <app-select class="selectDm7" 
                [options]="regimi" [key]="'val'" [value]="'label'"
                [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="utente!.regime_fiscale"
                (change)="utente!.regime_fiscale= $event.key;" [valClass]="utente!.regime_fiscale == '' ? 'borderRed' : ''"></app-select>
        </div>
    </div>

    <div class="row" style="margin-top:20px">
        <div  [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <!-- IBAN  -->
            <label  class="roboSubTitle">IBAN</label>
            <!--<div class="input-group"  style="flex: 1"> -->
                <input class="form-control" type="text"  [(ngModel)]="utente!.iban_list">
                <!--<span  class="input-group-text" id="basic-addon1" 
                            [ngClass]="utente!.iban_list.length > 0 ? 'bg-success text-white' : 'bg-danger text-white'" style="cursor:pointer"
                            (click)="aggiungiIban()" *ngIf="pdata!.iban_aggiuntivi!.length==0 && iban_aggiuntivi.length==0">
                    <i class="bi bi-plus-circle" [ngbTooltip]="'users.editor.iban_aggiuntivi' | translate"></i>
                </span>
            </div>-->
        </div>
            <!--<span style="visibility:hidden"></span>
            <div  *ngIf="iban_aggiuntivi.length > 0" class="mt-2" [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" >
                <label  class="roboSubTitle">IBAN AGGIUNTIVI 
                        <button class="btn btn-sm btn-success" [disabled]="esisteIbanNonConfermato()" (click)="aggiungiIbanAggiuntivo()">Aggiungi</button>
                </label>
                    <div class="input-group my-2"  style="flex: 1" *ngFor="let ibnAgg of iban_aggiuntivi ;index as i">
                            <input type="text" class="form-control" [(ngModel)]="ibnAgg.value"  [disabled]="ibnAgg.confirmed">
                            <span *ngIf="!ibnAgg.confirmed" class="input-group-text" id="basic-addon1" 
                            [ngClass]="ibnAgg.value.length > 0 ? 'bg-primary text-white' : 'bg-danger text-white'" style="cursor:pointer"
                            (click)="confermaIbanAggiuntivo(i)"><i class="bi bi-check-circle"></i></span>

                            <span *ngIf="ibnAgg.confirmed" class="input-group-text" id="basic-addon1" 
                            [ngClass]="ibnAgg.value.length > 0 ? 'bg-primary text-white' : 'bg-danger text-white'" style="cursor:pointer"
                            (click)="modificaIbanAggiuntivo(i)"><i class="bi bi-pencil-fill"></i></span>

                            <span  class="input-group-text bg-danger text-white" id="basic-addon1" style="cursor:pointer"
                            (click)="rimuoviIbanAggiuntivo(i)"><i class="bi bi-dash-circle"></i></span>
                    </div>
            </div>-->
        <div class="col-6">
            <!-- PARTITA IVA  -->
            <label for="pec" class="roboSubTitle">PEC</label>
            <input class="form-control" type="text" id="pec" [(ngModel)]="utente!.pec">
        </div>
    </div>

    <!-- SEDE -->
    <div class="row" style="margin-top:20px">
         <div class="col-9">
            <label for="indirizzo" class="roboSubTitle">Indirizzo e numero civico</label>
            <input class="form-control" type="text" id="indirizzo" [(ngModel)]="utente!.indirizzo">
        </div>
        <div class="col-3">
            <label for="comune" class="roboSubTitle">CAP</label>
            <input class="form-control" type="text" id="comune" [(ngModel)]="utente!.cap">
        </div>
    </div>
    <div class="row" style="margin-top:20px">
        <div class="col-3">
            <label for="comune" class="roboSubTitle">Comune</label>
            <input class="form-control" type="text" id="comune" [(ngModel)]="utente!.comune">
        </div>
         <div class="col-3">
            <label class="roboSubTitle">Provincia</label>
            <input class="form-control" type="text" [(ngModel)]="utente!.provincia">
        </div>
        <div class="col-3">
            <label class="roboSubTitle">Nazione</label>
            <input class="form-control" type="text" [(ngModel)]="utente!.nazione">
        </div>
    </div>



    <!--<div class="row" style="margin-top:20px"> 
        <div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             EMAIL notifiche fatturazione passiva  
            <label class="roboSubTitle">{{ 'users.editor.email_passiva' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="me.email_passiva" >
        </div>-->
        <!-- <div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            EMAIL notifiche ricezione ordini 
            <label  class="roboSubTitle">{{ 'users.editor.email_ordini' | translate }}</label>
            <input class="form-control" type="text"  [(ngModel)]="me.email_ricezione_ordini" >
        </div>

    </div> -->

    <!--<hr>
     MOSTRA DATI DM7 
    <div  [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" class="form-group form-check" style="margin-bottom: 5px;">
        <div >
            <input type="checkbox" class="form-check-input" [(ngModel)]="DM7info" >
            <label class="form-check-label" >{{'profile.showDM7info' | translate}}</label>
        </div>
    </div>-->
    <!-- <div class="row" style="margin-top:20px" *ngIf='DM7info'>
        <div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            SERVER
            <label  class="roboSubTitle">Server</label>
            <input class="form-control" type="text"  [(ngModel)]="me.dms_api_url" readonly>
                   
        </div>       --> 
        <!--<div  [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             AZIENDA 
            <label  class="roboSubTitle">{{'users.editor.company' | translate}}</label>
            <input class="form-control" type="text"  [(ngModel)]="me.dms_company_id" readonly>
        </div>        
    </div>   
    <hr>

    <app-personal-data #pdc
    [json_sdi_data]='me.json_sdi_data' 
    (change)='setJsonData($event)'></app-personal-data>-->





</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>
<router-outlet></router-outlet>
